import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

import SubSearch from 'components/search/SubSearch.vue';
import {useSearchStore} from 'stores/search-store';
import {storeToRefs} from "pinia";

export interface Props {
  enableBackButton?: boolean,
  enableNextButton?: boolean,
  enableSubSearch?: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ProcedureTableToolbar',
  props: {
    enableBackButton: { type: Boolean, default: false },
    enableNextButton: { type: Boolean, default: false },
    enableSubSearch: { type: Boolean, default: false }
  },
  emits: ["back-button-clicked", "next-button-clicked"],
  setup(__props: any, { emit: __emit }) {

const searchStore =  useSearchStore();
const {firstSubSearchPerformed} = storeToRefs(searchStore);

const props = __props

const emit = __emit

const onBackButtonClicked = () => {
  emit('back-button-clicked')
};

const onNextButtonClicked = () => {
  emit('next-button-clicked')
};

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!

  return (_openBlock(), _createBlock(_component_q_toolbar, {
    class: _normalizeClass([{'toolbar-sub-search': props.enableSubSearch && _unref(firstSubSearchPerformed)}, "io-mfe-ig-procedure-table-toolbar"])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_btn, {
        class: "iodine-button-outline io-mfe-ig-icon-button-medium",
        dense: "",
        round: "",
        unelevated: "",
        flat: "",
        size: "xs",
        icon: "fa-solid fa-arrow-left",
        disable: !props.enableBackButton,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (onBackButtonClicked()))
      }, null, 8, ["disable"]),
      _createVNode(_component_q_btn, {
        class: "iodine-button-outline io-mfe-ig-icon-button-medium",
        dense: "",
        round: "",
        unelevated: "",
        flat: "",
        size: "xs",
        icon: "fa-solid fa-arrow-right",
        disable: !props.enableNextButton,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (onNextButtonClicked()))
      }, null, 8, ["disable"]),
      (props.enableSubSearch && (_unref(searchStore).getBookTitle.endsWith('Index') || _unref(searchStore).getBookTitle.endsWith('Tabular')))
        ? (_openBlock(), _createBlock(SubSearch, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})